import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { TextField, DropDownMenu, MenuItem } from 'material-ui';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';


import Btn from '../../../components/Btn';
import '../../../grid.css';

class CAP extends Component {
    static propTypes = {
        capDownPayment: PropTypes.number.isRequired,
        setCAPDownPayment: PropTypes.func.isRequired,
        isVisible: PropTypes.bool.isRequired,
        isLocked: PropTypes.bool.isRequired,
        setCAPIsVisible: PropTypes.func.isRequired,
        showCAP: PropTypes.bool.isRequired,
        resiToggle: PropTypes.bool.isRequired,
        setShowCAP: PropTypes.func.isRequired,
        capTerm: PropTypes.number.isRequired,
        setCAPTerm: PropTypes.func.isRequired,
        setSelectedFinancing: PropTypes.func.isRequired,
    };

    toggleCAP() {
        const { setCAPIsVisible, isVisible } = this.props;
        setCAPIsVisible(!isVisible);
    }

    toggleShowCAP() {
        const { setShowCAP, showCAP, setSelectedFinancing } = this.props;
        setShowCAP(!showCAP);
        if (showCAP) {
            setSelectedFinancing(4);
        }
        if (!showCAP) {
            setSelectedFinancing(3);
        }
    }

    handleCAPTermChange(value) {
        const { setCAPTerm } = this.props;
        setCAPTerm(Number(value));
    }

    handleCAPDownPaymentChange(value) {
        const { setCAPDownPayment } = this.props;
        setCAPDownPayment(Number(value));
    }

    render() {
        const {
            isVisible,
            isLocked,
            showCAP,
            capDownPayment,
            capTerm,
            resiToggle,
        } = this.props;

        let isDisabled = isLocked;
        if (resiToggle === true || isLocked === true) {
            isDisabled = true;
        }


        return (
            <div>
                <Btn
                    label="Capital Lease"
                    onClick={(e, value) => this.toggleCAP(value)}
                />

                {isVisible ? (
                    <div>
                        <div className="col span-1-of-8 checkboxes">
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        disabled={isDisabled}
                                        onChange={(e, value) => this.toggleShowCAP(value)}
                                        checked={showCAP}
                                    />
                                }
                                label="Include CAP"
                            />
                        </div>
                        {showCAP ? (
                            <div>
                                <div className="col span-3-of-8">
                                    <TextField
                                        onChange={(e, value) =>
                                            this.handleCAPDownPaymentChange(value)}
                                        floatingLabelText="CAP Down Payment"
                                        disabled={isDisabled}
                                        defaultValue={capDownPayment}
                                    />
                                </div>
                                <div className="col span-1-of-4">
                                    <DropDownMenu
                                        fullWidth
                                        label="CAP Term"
                                        value={capTerm}
                                        onChange={(e, index, value) =>
                                            this.handleCAPTermChange(value)}
                                        disabled={isDisabled}
                                    >
                                        <MenuItem value={36} primaryText="36 Month" />
                                        <MenuItem value={48} primaryText="48 Month" />
                                        <MenuItem value={60} primaryText="60 Month" />
                                        <MenuItem value={72} primaryText="72 Month" />
                                        <MenuItem value={84} primaryText="84 Month" />
                                    </DropDownMenu>
                                </div>
                            </div>
                        ) : null}
                    </div>
                ) : null}
            </div>
        );
    }
}

export default CAP;



// WEBPACK FOOTER //
// ./src/containers/Inputs/CAP/CAP.js